import { CalendarIcon } from "./icons";

/**
 * The trip happening right now, shown as progress rather than as another photo
 * card. Day and percentage are derived from the trip's own dates — there is no
 * check-in signal in the data, so nothing here claims to know where the
 * traveller physically is.
 */
export default function OngoingTripCard({ trip, onViewDetails }) {
  const dayOf = (value) => new Date(new Date(value).setHours(0, 0, 0, 0)).getTime();
  const today = dayOf(new Date());
  const start = dayOf(trip.startDate);
  const end = dayOf(trip.endDate);

  const totalDays = Math.max(1, Math.round((end - start) / 86400000) + 1);
  const currentDay = Math.min(totalDays, Math.max(1, Math.round((today - start) / 86400000) + 1));
  const percent = Math.round((currentDay / totalDays) * 100);

  const title = trip.itinerary?.tripSummary?.tripTitle || `Trip to ${trip.destination}`;

  return (
    <div className="bg-white rounded-2xl border border-teal-200 shadow-sm p-5 flex flex-col h-full">
      <div className="flex items-start justify-between gap-3 mb-3">
        <h3 className="font-semibold text-gray-900 leading-snug line-clamp-2 break-words">
          {title}
        </h3>
        <span className="shrink-0 px-2.5 py-1 rounded-full bg-orange-50 text-orange-600 text-[11px] font-semibold flex items-center gap-1.5">
          <span className="w-1.5 h-1.5 rounded-full bg-orange-500 animate-pulse-soft" />
          Ongoing
        </span>
      </div>

      <p className="text-sm text-gray-500 flex items-center gap-1.5 mb-5">
        <CalendarIcon />
        <span className="ml-0.5">{trip.destination}</span>
      </p>

      <div className="mt-auto">
        <div className="flex items-center justify-between text-xs mb-1.5">
          <span className="font-medium text-gray-600">
            Day {currentDay} of {totalDays}
          </span>
          <span className="font-semibold text-teal-700 tabular-nums">{percent}%</span>
        </div>
        <span className="block h-2 w-full bg-gray-100 rounded-full overflow-hidden">
          <span
            className="block h-full bg-teal-600 rounded-full transition-all duration-500"
            style={{ width: `${percent}%` }}
          />
        </span>

        <button
          type="button"
          onClick={() => onViewDetails(trip)}
          className="mt-4 w-full py-2.5 rounded-lg bg-teal-700 text-white text-sm font-semibold hover:bg-teal-800 transition-colors cursor-pointer"
        >
          Continue trip →
        </button>
      </div>
    </div>
  );
}
